import createModule from "../createModule"
import view from "./view"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "./model"
import { Creators as NotificationCreators } from "modules/notifications/model"
import { getGeneratedSummary, getAiResource, getSummaryKey, getSummaries } from "./selectors"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    isSuperuser: state.user.isSuperuser,
    resourceIdOrAlias: props.resourceId,
    resourceType: props.resourceType,
  }),
  required: ["account"],
  data: [{
    resource: "aiSummaryResource",
    url: ({ account, resourceIdOrAlias, resourceType }) => ({
      id: `aiSummaryResource-${account}-${resourceIdOrAlias}-${resourceType}`,
      query: `query ($resourceIdOrAlias: IdOrShortIdOrAlias!, $resourceType: ResourceType!) {
        resource(id: $resourceIdOrAlias, type: $resourceType) {
          alias
          type
          name
          updatedAt
        }
      }`,
      variables: {
        resourceIdOrAlias,
        resourceType,
      },
    }),
  }],
  mapStateToProps: (state, props) => ({
    generatedSummary: getGeneratedSummary(state, props),
    generatedSummaries: getSummaries(state, props),
    resource: getAiResource(state, props),
    summaryKey: getSummaryKey(state, props),
  }),
  actions: {
    ...Creators,
    addNotification: NotificationCreators.add,
  },
}))
